import React, { useState } from 'react'
import { Drawer, Button } from 'antd'
import {
	ControlOutlined,
	CloseOutlined,
	CloseCircleOutlined,
} from '@ant-design/icons'

import './index.scss'

const FilterSidebar = ({ children, hasClear, clearFilters }) => {
	const [visible, setVisible] = useState(false)

	const showDrawer = () => setVisible(true)
	const onClose = () => setVisible(false)

	return (
		<>
			{hasClear && (
				<Button
					type="default"
					onClick={clearFilters}
					icon={<CloseCircleOutlined />}>
					Limpar filtros
				</Button>
			)}
			<Button
				type="text"
				className="filter-trigger-btn"
				icon={<ControlOutlined />}
				onClick={showDrawer}>
				Mais filtros
			</Button>

			<Drawer
				title={
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span
							style={{ fontWeight: 600, fontSize: '16px', color: '#101828' }}>
							Seleção de filtros
						</span>
					</div>
				}
				placement="right"
				closable={true}
				onClose={onClose}
				open={visible}
				width={380}
				className="filter-sidebar-drawer"
				closeIcon={<CloseOutlined style={{ color: '#667085' }} />}
				styles={{
					header: { borderBottom: '1px solid #EAECF0', padding: '20px 24px' },
					body: { padding: 0 },
				}}>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					{children}
				</div>
			</Drawer>
		</>
	)
}

export default FilterSidebar
